// Mock data for Frontier Investments website

export const testimonials = [
  {
    id: 1,
    quote: "What stood out to me was that everything they presented to me was Process Driven - from Planning my SIPs to Structuring my Wealth. Never thought that Investments needed so much attention. They explained to me the importance of having a long-term outlook & following a scientific approach. Quite impressed by their care and concern in making sure we are Investing in the right place and moving in the right direction. I have added consistently to my portfolio over the years based on their views, plans & strategy and my portfolio has grown impressively.",
    name: "Vijay Krishna",
    role: "Head – Technical & Capacity Development, Global Sovereign Institution, Hong Kong",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/f3220472f67cac60123ed9ddca71ef17ffdec815024c61775b9e57e49335ff44.png"
  },
  {
    id: 2,
    quote: "Always thought the best way to invest was just investing across a number of Mutual Funds until I met the Team at Frontier. They educated me on the basic tenets of Diversification and Portfolio Construction. The Team came up with a portfolio that matched my Risk Profile and one that was built on robust Fundamentals. Over the years I have brought in my entire family's portfolio under the Team's guidance. & happy with the decision.",
    name: "Dr. Sanjay Melwani",
    role: "Manipal Hospitals",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/ee08758496f9f378927e1e30c40d22872444f2e8b1cb6a832ad6202629b63936.png"
  },
  {
    id: 3,
    quote: "I have been investing for quite a few years now. The day I realised that my Relationship Manager's advice was not aligning with my interest, I lost confidence and was looking for a change. I was referred to Frontier Investments by a friend of mine. When I met the Team I felt immediately comfortable as their approach was calm and collected as they heard me out patiently - I felt no pressure. They came back to me with a Plan that was Long-term in outlook yet proactive & well-grounded in Fundamentals.",
    name: "Ramesh Patel",
    role: "Global Supply Chain Executive, Tech Industry, UK",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/790bb6b06117fa32ebd4b09ca504fc00ce736733589d97a0548bf9a9d6e44984.png"
  },
  {
    id: 4,
    quote: "I have been with Frontier Investments for almost a decade now. When I heard about Mutual Funds for the first time I didn't know how to start and was looking for some help. This is when I first met Frontier Investments. They educated me on the basics of Investing & Mutual Funds and helped me build my portfolio brick by brick. Even though I started small they gave me full attention and took good care of my portfolio. Today, I can say with conviction about Frontier's exceptional services as my portfolio has grown immensely.",
    name: "Arvind V.",
    role: "Head – Cybersecurity, Major Indian E-Commerce Leader, India",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/720bf4f9a05745ba775c9c55872e88aac3066bddb101d87d49079b6595b70a4f.png"
  },
  {
    id: 5,
    quote: "I usually invested when there was a good amount of positive news in the markets and the economy, thinking that it was the right time to Invest and suffered soon thereafter. When I met the team at Frontier they explained to me the concept of Asset Allocation and having a systematic approach to Investing. They suggested me to stay away from market noise and focus on the fundamentals & have a long-term approach. This detailed discussion with them was transformational for me and a turning point in my investing journey. Today, I remain calm & confident knowing that I am making this journey with an experienced helmsman.",
    name: "Deepak S.",
    role: "Chief Procurement Officer, Diversified Conglomerate, UAE, Middle East",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/cf23fdd4e4168202d9cf6f6673ef349c72c528298ecc4f68a67f13218e3db1aa.png"
  },
  {
    id: 6,
    quote: "I was just around 12 years away from retiring and had a family to support. I was wondering how I could safeguard my lifestyle expenses after retirement and yet support goals of my children at the same time. The discussion I had with Frontier's Team was a game changer for me as they took full control of the scenario and charted out a comprehensive SIP & Wealth plan. The plan gave me realistic visibility into the future – this put all my worries to rest and gave me new found sense of freedom & confidence.",
    name: "Dr. Seema N.",
    role: "Dental Surgeon, Sparsh Hospitals, Bangalore",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/0ba42853f00df98607aa3244846f756879fc3acef77ba0210f16ebf6eea72198.png"
  },
  {
    id: 7,
    quote: "Considering my relatively large corpus, I was not happy with the existing set-up as I felt the advisors on the platform were treading a thin line by constantly pushing products that I felt were opaque and lacked transparency. I was referred to Frontier Investments by my colleague as I was looking for a highly professional & experienced Team, especially with large size portfolios. I was impressed with the depth and understanding of the Team here as they took me through their Investment Framework, the Process & Strategies that were key in steering large portfolios across market cycles very successfully over the years. A right place for me.",
    name: "Sunil Shetty",
    role: "Director Silk Routes – Global Silk Exports, India",
    image: "https://static.prod-images.emergentagent.com/jobs/f05b17bd-e518-4802-836f-82276c509943/images/6101b49c17edb3db3da3876474868d1821a5890206f0d99f1c6eaf1d19510850.png"
  }
];

export const investmentProcess = [
  {
    id: 1,
    step: "01",
    title: "Customer Objectives",
    description: "Establishes the foundation by assessing goals, risk appetite, and net worth to tailor the investment approach.",
    frontierApproach: "We deeply understand your unique financial aspirations through personalized consultations",
    traditionalApproach: "Generic questionnaires with little personalization"
  },
  {
    id: 2,
    step: "02",
    title: "Asset Allocation Alignment",
    description: "Aligns customer insights with macro trends and risk profile for diversified allocation across asset classes.",
    frontierApproach: "Data-driven allocation optimized for your goals with regular rebalancing",
    traditionalApproach: "One-size-fits-all allocation templates"
  },
  {
    id: 3,
    step: "03",
    title: "Portfolio Mapping",
    description: "Fund category evaluation, fund selection framework and how Frontier can help you.",
    frontierApproach: "Active monitoring with timely tactical adjustments based on market conditions",
    traditionalApproach: "Set-and-forget approach with rare reviews"
  },
  {
    id: 4,
    step: "04",
    title: "Portfolio Review",
    description: "Regularly reviews fund performance, risk exposure, and rebalances to align with evolving financial goals.",
    frontierApproach: "Transparent quarterly reviews with detailed insights and recommendations",
    traditionalApproach: "Annual reports with outdated information"
  }
];

export const services = [
  {
    id: 1,
    title: "Corpus Builder",
    description: "Build long-term prosperity through strategies aligned with your goals & risk profile.",
    icon: "TrendingUp",
    color: "from-emerald-500 to-teal-500",
    link: "/wealth-builder",
    features: [
      "Personalized wealth growth strategies",
      "Tax-efficient investment planning",
      "Regular portfolio rebalancing",
      "Dedicated relationship manager"
    ],
    details: "Our Corpus Builder program is designed for HNIs and entrepreneurs who want to create long-term wealth through disciplined investing. We analyze your financial situation, risk tolerance, and goals to create a customized portfolio. Without a long-term plan, your wealth may not last as long as you expect."
  },
  {
    id: 2,
    title: "Goal Planner",
    description: "Achieve life milestones with goal-based investment strategies designed for success.",
    icon: "Target",
    color: "from-blue-500 to-indigo-500",
    link: "/goal-planner",
    features: [
      "Life milestone planning",
      "Child education funding",
      "Marriage expense planning",
      "Custom SIP strategies"
    ],
    details: "Big or small, everyone has life goals — some close, some far away. Whether it's building a fund for your child's education, planning a dream wedding, or preparing for a comfortable retirement, goals give structure to your finances and direction to your life."
  },
  {
    id: 3,
    title: "Insurance Plans",
    description: "Comprehensive protection solutions to secure your family's financial future.",
    icon: "Shield",
    color: "from-purple-500 to-pink-500",
    link: "/insurance",
    features: [
      "Term life insurance",
      "Health insurance planning",
      "Critical illness coverage",
      "Claim assistance support"
    ],
    details: "Our Insurance Plans ensure your family's financial security is never compromised. We help you choose the right coverage amount and policy type based on your needs, income, and family situation."
  },
  {
    id: 4,
    title: "Retirement Planning",
    description: "Plan for a comfortable retirement with strategies that ensure financial independence.",
    icon: "Sunset",
    color: "from-orange-500 to-red-500",
    link: "/retirement",
    features: [
      "Retirement corpus calculation",
      "Pension plan optimization",
      "Post-retirement income planning",
      "Healthcare cost planning"
    ],
    details: "Plan for a comfortable retirement with our comprehensive Retirement Planning service. We calculate your required corpus considering inflation, lifestyle, and healthcare needs to ensure you maintain your standard of living."
  },
  {
    id: 5,
    title: "Tax Optimization",
    description: "Maximize returns with tax-efficient investment strategies and planning.",
    icon: "Calculator",
    color: "from-cyan-500 to-blue-500",
    link: "/tax-optimization",
    features: [
      "ELSS mutual fund selection",
      "80C investment optimization",
      "Capital gains management",
      "Tax harvesting strategies"
    ],
    details: "Maximize your post-tax returns with our Tax Optimization strategies. We help you save taxes legally while ensuring your investments align with your overall financial goals."
  },
  {
    id: 6,
    title: "NRI Connect",
    description: "Specialized services for NRIs with cross-border investment expertise.",
    icon: "Globe",
    color: "from-violet-500 to-purple-500",
    link: "/nri",
    features: [
      "NRE/NRO account guidance",
      "DTAA benefit optimization",
      "Repatriation assistance",
      "Estate planning for NRIs"
    ],
    details: "At Frontier Investments, we understand the unique financial needs of Non-Resident Indians. Our dedicated NRI services are designed to offer end-to-end solutions that ensure compliance, growth, and peace of mind."
  }
];

export const calculators = [
  {
    id: 1,
    title: "Crorepati Calculator",
    description: "Plan your path to ₹1 crore by estimating investment amounts, returns, and timelines.",
    icon: "BarChart3",
    features: ["Target Amount: Aim for ₹1 Cr+ corpus", "Time Horizon: Set your goal year", "SIP Needed: Plan monthly investment"]
  },
  {
    id: 2,
    title: "Marriage Planning",
    description: "Set a realistic budget and plan for your child's wedding with smart SIP strategies.",
    icon: "Heart",
    features: ["Cost Estimate: Set a realistic budget", "Time Frame: Plan by their wedding age", "SIP Strategy: Invest monthly with ease"]
  },
  {
    id: 3,
    title: "Education Planning",
    description: "Estimate future education expenses and invest monthly to stay ready.",
    icon: "GraduationCap",
    features: ["Tuition Costs: Estimate future expenses", "Timeline: Plan by admission year", "SIP Amount: Invest monthly to stay ready"]
  },
  {
    id: 4,
    title: "House Planning",
    description: "Set your property target and build your down payment with smart SWP planning.",
    icon: "Home",
    features: ["Budget Goal: Set your property target", "Time Frame: Choose your purchase year", "SIP Planning: Build your down payment"]
  },
  {
    id: 5,
    title: "Emergency Fund Builder",
    description: "Set 6-12 months of expenses for emergency fund with high liquidity.",
    icon: "AlertTriangle",
    features: ["Fund Size: Set 6–12 months of expenses", "Access: Keep liquidity high and risk low", "Peace of Mind: Be prepared for any surprise"]
  },
  {
    id: 6,
    title: "Portfolio Forecasting",
    description: "Plan investments across asset classes and estimate post-retirement withdrawals.",
    icon: "PieChart",
    features: ["Asset Allocation: Plan investments across classes", "Corpus: Set your retirement goal", "SWP: Estimate post-retirement withdrawals"]
  }
];

export const team = [
  {
    id: 1,
    name: "Vikram Raghavan",
    role: "Founder & CEO",
    description: "20+ years in mutual fund distribution",
    image: "https://images.unsplash.com/photo-1637589274892-9bc2d5200eab?w=400&h=400&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Priya Venkatesh",
    role: "Chief Investment Officer",
    description: "Former Goldman Sachs VP",
    image: "https://images.unsplash.com/photo-1607189200597-4d0923ef98c6?w=400&h=400&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Sanjay Iyer",
    role: "Head of Research",
    description: "CFA Charterholder, 15+ years experience",
    image: "https://images.unsplash.com/photo-1524081081171-7960da1de373?w=400&h=400&fit=crop&crop=face"
  }
];

export const clientPartners = [
  {
    id: 1,
    name: "Deepa Krishnan",
    role: "Senior Wealth Advisor",
    image: "https://images.unsplash.com/photo-1618559850638-2aed8a8e8cdc?w=400&h=400&fit=crop&crop=face",
    clients: [
      "Founder of leading healthcare chain",
      "CEO of multinational tech company",
      "Promoter of FMCG conglomerate"
    ]
  },
  {
    id: 2,
    name: "Arjun Nair",
    role: "Client Partner",
    image: "https://images.unsplash.com/flagged/photo-1571367034861-e6729ad9c2d5?w=400&h=400&fit=crop&crop=face",
    clients: [
      "Founder of India's top SaaS company",
      "Managing Director of PE fund",
      "Promoter of real estate group"
    ]
  },
  {
    id: 3,
    name: "Kavitha Subramaniam",
    role: "Wealth Strategist",
    image: "https://images.unsplash.com/photo-1534235187448-833893dfe3e0?w=400&h=400&fit=crop&crop=face",
    clients: [
      "CFO of listed pharma company",
      "Founder of ed-tech unicorn",
      "Director of hospitality group"
    ]
  }
];

export const partners = [
  { id: 1, name: "SBI Mutual Fund", logo: "https://frontierinvestments.co/images/sbimf.jpg" },
  { id: 2, name: "Bajaj Finserv", logo: "https://frontierinvestments.co/images/bajaj.jpg" },
  { id: 3, name: "Bandhan Bank", logo: "https://frontierinvestments.co/images/bandhan.jpg" },
  { id: 4, name: "HDFC MF", logo: "https://seekvectorlogo.com/wp-content/uploads/2019/02/hdfc-mutual-fund-vector-logo.png" },
  { id: 5, name: "ICICI Prudential", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/ICICI-Prudential-Mutual-Fund.jpg/1200px-ICICI-Prudential-Mutual-Fund.jpg" },
  { id: 6, name: "Nippon India", logo: "https://logowik.com/content/uploads/images/nippon-india-mutual-fund3594.jpg" },
  { id: 7, name: "UTI MF", logo: "https://frontierinvestments.co/images/utimf.jpg" },
  { id: 8, name: "Edelweiss", logo: "https://frontierinvestments.co/images/edelweiss.jpg" },
  { id: 9, name: "Tata MF", logo: "https://frontierinvestments.co/images/tataMF.jpg" },
  { id: 10, name: "Kotak MF", logo: "https://frontierinvestments.co/images/kotakMF.png" }
];

export const nriServices = [
  {
    id: 1,
    title: "Taxation Guidelines & Support",
    description: "Expert guidance on DTAA benefits, capital gains, TDS management, and FATCA/CRS compliance.",
    features: [
      "DTAA benefit optimization",
      "Capital gains tax management",
      "TDS recovery assistance",
      "FATCA/CRS compliance"
    ]
  },
  {
    id: 2,
    title: "Investment Guidance",
    description: "Tailored mutual fund portfolios through NRE/NRO accounts with goal-oriented strategies.",
    features: [
      "NRE/NRO account guidance",
      "SIP/STP setup assistance",
      "Goal-oriented portfolios",
      "Risk-adjusted strategies"
    ]
  },
  {
    id: 3,
    title: "Regulatory Compliance",
    description: "Seamless onboarding with KYC for NRIs, FEMA-compliant documentation.",
    features: [
      "KYC for NRIs",
      "FEMA-compliant documentation",
      "Repatriation assistance",
      "RBI-compliant investment routes"
    ]
  },
  {
    id: 4,
    title: "Estate Planning",
    description: "Structuring investments with clear nomination and will-based planning.",
    features: [
      "Will-based planning",
      "Nomination setup",
      "Asset consolidation",
      "Generational transfer"
    ]
  }
];

export const nriFAQs = [
  {
    id: 1,
    question: "Can NRIs invest in Indian mutual funds?",
    answer: "Yes, NRIs can invest in Indian mutual funds, subject to compliance with the Foreign Exchange Management Act (FEMA) and other regulations laid down by SEBI."
  },
  {
    id: 2,
    question: "What types of accounts do NRIs need to invest in mutual funds in India?",
    answer: "NRIs need to have either a NRE (Non-Resident External) or NRO (Non-Resident Ordinary) bank account. Investments can be made through these accounts or via FCNR accounts."
  },
  {
    id: 3,
    question: "Can NRIs repatriate their mutual fund investments?",
    answer: "Yes, investments made through an NRE or FCNR account are fully repatriable. Investments made through an NRO account are repatriable up to a limit set by the RBI."
  },
  {
    id: 4,
    question: "Is PAN mandatory for NRIs to invest in mutual funds in India?",
    answer: "Yes, NRIs must have a Permanent Account Number (PAN) to invest in mutual funds in India."
  },
  {
    id: 5,
    question: "How are mutual fund investments taxed for NRIs?",
    answer: "Equity mutual funds are taxed at 15% for short-term gains (if held for less than one year) and 10% for long-term gains (above ₹1 lakh, held for more than one year). Debt funds attract 30% short-term capital gains tax and 20% long-term tax with indexation."
  },
  {
    id: 6,
    question: "Do NRIs need to pay TDS on mutual fund redemptions?",
    answer: "Yes, TDS is applicable on mutual fund redemptions by NRIs. The TDS rates are 10% for long-term capital gains from equity funds and 20% for long-term capital gains from debt funds."
  },
  {
    id: 7,
    question: "Are SIPs available for NRIs?",
    answer: "Yes, NRIs can start SIPs in mutual funds. They can invest regularly through SIPs by setting up automatic debits from their NRE/NRO accounts."
  },
  {
    id: 8,
    question: "What documents are required for NRI investment?",
    answer: "NRIs need to provide KYC Compliance (PAN card, Valid passport, Proof of overseas address, Recent photograph), Completed Mutual Fund Application Form, FATCA Declaration, and Bank Account Proof."
  }
];

export const stats = [
  { value: "20+", label: "Years Experience" },
  { value: "98%", label: "Client Retention" },
  { value: "Zero", label: "Hidden Charges" }
];

export const wealthBuilderContent = {
  title: "Why Specialised Investment Services Matters for HNIs & Entrepreneurs",
  intro: "Despite building impressive businesses and accumulating significant wealth, many affluent families and high-net-worth individuals struggle to preserve and grow that wealth across generations. The challenge isn't capability—it's often time, bandwidth, and structure.",
  sections: [
    {
      icon: "TrendingDown",
      title: "Wealth Can Erode Without Structure",
      points: [
        "Ad hoc investing often leads to fragmented portfolios and risk exposure",
        "Overdependence on one business or asset class can increase vulnerability",
        "Taxes, inflation, and lifestyle creep can quietly chip away your wealth"
      ]
    },
    {
      icon: "Clock",
      title: "Time is Scarce for Business Owners",
      points: [
        "Running a business leaves little room to manage complex investments",
        "Monitoring market trends, regulations, and taxes requires full-time attention",
        "DIY investing often lacks professional risk management and discipline"
      ]
    },
    {
      icon: "Target",
      title: "The 'Next Big Thing' Trap",
      points: [
        "Everyone wants the next multi-bagger, but that mindset can backfire",
        "Chasing trends often leads to losses and missed fundamentals",
        "True wealth compounds through patience, not speculation"
      ]
    },
    {
      icon: "Users",
      title: "Multi-Generational Planning",
      points: [
        "Legacy is more than inheritance—it's about preparing the next generation",
        "Proper estate planning ensures your assets don't fall into legal disputes",
        "Your values and legacy deserve a long-term blueprint—not guesswork"
      ]
    }
  ]
};

export const goalPlannerContent = {
  title: "Why Should You Have a Goal Planner?",
  intro: "Big or small, everyone has life goals — some close, some far away. Whether it's building a fund for your child's education, planning a dream wedding, or preparing for a comfortable retirement, goals give structure to your finances and direction to your life.",
  sections: [
    {
      icon: "Target",
      title: "Clarity On What You're Saving For",
      description: "A vague goal leads to vague outcomes. Defining specific financial goals helps:",
      points: [
        "Set realistic savings targets",
        "Choose the right investment strategies",
        "Track progress and stay motivated over time"
      ]
    },
    {
      icon: "TrendingUp",
      title: "Stay Ahead of Inflation",
      description: "If your money grows slower than inflation, you're losing wealth. Goal-based planning ensures:",
      points: [
        "Your savings stay relevant in future value terms",
        "Asset allocation keeps pace with market conditions",
        "Periodic reviews keep your plan adaptive and realistic"
      ]
    },
    {
      icon: "Shield",
      title: "Peace of Mind During Life's Big Moments",
      description: "When it's time for your child's college, your retirement, or that long-awaited dream — the last thing you want is financial stress. A Goal Planner ensures:",
      points: [
        "You're financially ready, without scrambling or borrowing",
        "Stress-free transitions between life stages",
        "Confidence in every big life decision, backed by preparation"
      ]
    }
  ]
};
